import { createContext, useContext } from 'react';

import type { GuideMessagingDto } from '../types/GuideMessaging';

const initialContext = {
    guideMessaging: null as GuideMessagingDto | null,
    isLoading: true,
};

export const GuideMessagingContext =
    createContext<typeof initialContext>(initialContext);

const useGuideMessaging = () => {
    const context = useContext(GuideMessagingContext);

    if (context == null) {
        throw new Error(
            'useGuideMessaging must be used within GuideMessagingProvider',
        );
    }

    return context;
};

export default useGuideMessaging;
